import {validatorTypes} from '@utils/validators';

export const CIDR_RANGES_MAX_LENGTH = 1000;
export const INVALID_CIDR_FORMAT = 'Invalid CIDR format';
export const CIDR_WIDE_RANGE_WARNING_TEXT = 'This CIDR range contains more than 256 IPs.';

const IPV4_WIDE_RANGE_PREFIX = 24;
const IPV6_WIDE_RANGE_PREFIX = 120;

export const splitCidrTokens = (value) => (
    String(value || '')
        .split(/[,\n]/)
        .map((token) => token.trim())
        .filter(Boolean)
);

export const formatCidrsForDisplay = (value) => splitCidrTokens(value).join(',\n');

export const formatCidrsForStorage = (value) => splitCidrTokens(value).join(', ');

export const isCidrWiderThan256Ips = (token) => {
    const prefix = parseInt(token.split('/')[1], 10);

    if (!validatorTypes.cidrIPv4.validate(token)) {
        return prefix < IPV4_WIDE_RANGE_PREFIX;
    }

    if (!validatorTypes.cidrIPv6.validate(token)) {
        return prefix < IPV6_WIDE_RANGE_PREFIX;
    }

    return false;
};
